import {
  AcatsTransferStatus,
  CashTransferStatus,
  CategorizationType,
  LiquidateDirectIndexPortfolioStatus,
  namedOperations,
  OrderStatus,
  StatusEnum,
} from "../generated/graphql";

export const isStatusTerminal = (status: StatusEnum): boolean => {
  return [
    StatusEnum.Canceled,
    StatusEnum.Completed,
    StatusEnum.Executed,
    StatusEnum.Failed,
  ].includes(status);
};

export const mapOrderStatus = (status: OrderStatus): StatusEnum => {
  switch (status) {
    case OrderStatus.Canceled:
      return StatusEnum.Canceled;
    case OrderStatus.Rejected:
      return StatusEnum.Failed;
    case OrderStatus.CancelRequested:
    case OrderStatus.CancelPending:
      return StatusEnum.PendingCancellation;
    case OrderStatus.Pending:
    case OrderStatus.UserInitiated:
    case OrderStatus.AdminInitiated:
      return StatusEnum.Pending;
    case OrderStatus.Queued:
      return StatusEnum.Queued;
    case OrderStatus.Executed:
      return StatusEnum.Executed;
    case OrderStatus.NotFilled:
    case OrderStatus.Filled:
      return StatusEnum.Completed;
    default:
      return StatusEnum.Unknown;
  }
};

export const mapCashTransferStatus = (
  status: CashTransferStatus,
): StatusEnum => {
  switch (status) {
    case CashTransferStatus.CancelPending:
    case CashTransferStatus.CancelRequested:
      return StatusEnum.PendingCancellation;
    case CashTransferStatus.Pending:
    case CashTransferStatus.UserInitiated:
    case CashTransferStatus.FundsPosted:
    case CashTransferStatus.OpsReviewRequired:
    case CashTransferStatus.OpsApproved:
      return StatusEnum.Pending;
    case CashTransferStatus.Completed:
      return StatusEnum.Completed;
    case CashTransferStatus.Returned:
      return StatusEnum.Returned;
    case CashTransferStatus.Canceled:
      return StatusEnum.Canceled;
    case CashTransferStatus.OpsRejected:
    case CashTransferStatus.Rejected:
      return StatusEnum.Failed;
    default:
      return StatusEnum.Unknown;
  }
};

export const mapAcatsStatus = (status: AcatsTransferStatus): StatusEnum => {
  switch (status) {
    case AcatsTransferStatus.AdminInitiated:
    case AcatsTransferStatus.Initiated:
    case AcatsTransferStatus.RequestError:
      return StatusEnum.Initiated;
    case AcatsTransferStatus.Review:
    case AcatsTransferStatus.OpsRetry:
      return StatusEnum.Review;
    case AcatsTransferStatus.Complete:
    case AcatsTransferStatus.Purge:
      return StatusEnum.Completed;
    case AcatsTransferStatus.OpsRejected:
      return StatusEnum.Failed;
    case AcatsTransferStatus.SettleClose:
    case AcatsTransferStatus.OpsSmaCheck:
      return StatusEnum.SettleClose;
    default:
      return StatusEnum.Unknown;
  }
};

export const mapLiquidationStatus = (
  status: LiquidateDirectIndexPortfolioStatus,
): StatusEnum => {
  switch (status) {
    case LiquidateDirectIndexPortfolioStatus.Requested:
    case LiquidateDirectIndexPortfolioStatus.Pending:
      return StatusEnum.Pending;
    case LiquidateDirectIndexPortfolioStatus.Completed:
      return StatusEnum.Completed;
    case LiquidateDirectIndexPortfolioStatus.Canceled:
      return StatusEnum.Canceled;
    case LiquidateDirectIndexPortfolioStatus.Failed:
      return StatusEnum.Failed;
    default:
      return StatusEnum.Unknown;
  }
};

export const isJointAccount = (
  categorizationType: CategorizationType,
): boolean => {
  return categorizationType === CategorizationType.Joint;
};

export const refetchActivityQueries = [
  namedOperations.Query.simpleActivity,
  namedOperations.Query.simpleActivityById,
];
